import React from 'react'; 
import PropTypes from 'prop-types';

const LinkButton = ({ text, onClick, disabled, error, isSimple }) => {
	if (isSimple)
		return (
			<button type="button" className="btn btn-link" onClick={onClick} disabled={disabled}>
				<span className="fortis-Button" dangerouslySetInnerHTML={{ __html: text }} />
			</button>);
	else
		return (
			<div>
				<div className={"nav-btn"}>
					<button type="button" className="btn btn-link" onClick={onClick} disabled={disabled}>
						<span className="fortis-Button" dangerouslySetInnerHTML={{ __html: text }} />
					</button>
				</div>
				{error && <div className="text-danger">{error}</div>}
			</div>
		);
};
LinkButton.propTypes = {
	text: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
	error: PropTypes.string,
	isSimple: PropTypes.bool,
};
export default LinkButton;